import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-pdf-viewer',
    templateUrl: './pdf-viewer.component.html',
    styleUrls: ['./pdf-viewer.component.scss'],
    standalone: false,
})
export class PdfViewerComponent {
    @Input() set src(source: string) {
        this.blob = source;
    }

    blob: string;
}
